var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spaceship"},[_c('img',{attrs:{"src":"/images/mothership_logo_256.webp"}})])}]

export { render, staticRenderFns }